import { Component, Input, inject, ChangeDetectionStrategy } from '@angular/core';
import { ModalController } from '@ionic/angular/lazy';
import { TranslationService } from 'src/app/services/i18n/translation.service';

export type PrivacyDocType = 'trattamento' | 'finalita';

@Component({
  selector: 'app-modale-privacy-doc',
  templateUrl: './modale-privacy-doc.page.html',
  styleUrls: ['./modale-privacy-doc.page.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ModalePrivacyDocPage {
  @Input() docType: PrivacyDocType = 'trattamento';

  translation = inject(TranslationService);

  constructor(private modalCtrl: ModalController) { }

  dismiss() {
    this.modalCtrl.dismiss();
  }
}
